import { render } from "./AmiSéminairePage.vue?vue&type=template&id=68be4290"
import script from "./AmiSéminairePage.vue?vue&type=script&lang=js"
export * from "./AmiSéminairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__